import React, { useRef, useState } from 'react';
import logo from './logo.svg';
import './App.css';
import { useDropzone } from 'react-dropzone';
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile, toBlobURL } from '@ffmpeg/util';
import { AwesomeButtonProgress } from "react-awesome-button";
import 'react-awesome-button/dist/styles.css';
import { DownloadIcon, RocketIcon } from "@primer/octicons-react";
import fileDownload from 'js-file-download'
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

enum FileState {
  WAITING_FOR_SELECTION,
  SELECTED,
  PROCESSING,
  PROCESSED,
}

function App() {
  return (
    <div className="App">
      <header className="AppHeader">
        <p style={{ fontFamily: "'Kalam', cursive" }}> प्रधानमंत्री आशीर्वाद योजना (PM-AAYO)</p>
        <GiphyCreditNahiChahiye />
      </header>
      {/*
      <BrowserView>
      */}
        <AppLogic />
      {/*
      </BrowserView>
      <MobileView>
        Mobile devices not supported yet. Please use a desktop browser.
      </MobileView>
      */}
    </div>
  );
}

function GiphyCreditNahiChahiye() {
  return (
    <div style={{ width: '100%' }}>
      <div style={{ height: '0', paddingBottom: '82.11920529801324%', position: 'relative', width: '100%' }}>
        <iframe frameBorder="0" height="100%" src="https://giphy.com/embed/g4UNy5Pp1gefzJXBqT/video" style={{ left: '0', position: 'absolute', top: '0' }} width="100%">
        </iframe>
      </div>
    </div >
  );
}

function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function AppLogic() {
  const [fileState, setFileState] = useState<FileState>(FileState.WAITING_FOR_SELECTION);
  const [ffmpegLoaded, setFFMPEGLoaded] = useState(false);
  const ffmpegRef = useRef(new FFmpeg());
  const [mediaURL, setMediaURL] = useState<string | null>(null);
  const [msgString, setMsgString] = useState<string | null>("Loading...");
  const [outputType, setOutputType] = useState<'gif' | 'mp4'>('mp4');

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone(
    {
      accept: {
        //'image/png': ['.png'],
        //'image/jpeg': ['.jpg', '.jpeg'],
        'video/mp4': ['.mp4'],
      },
      maxFiles: 1,
      onDrop: (acceptedFiles) => {
        console.log(acceptedFiles);
        setFileState(FileState.SELECTED);
      }
    }
  );

  const files = acceptedFiles.map(file => (
    <p key={file.name}>
      {file.name} - {file.size} bytes
    </p>
  ));


  const loadFFMPEG = async () => {
    if (!ffmpegLoaded) {
      const baseURL = 'https://unpkg.com/@ffmpeg/core@0.12.2/dist/umd'
      const ffmpeg = ffmpegRef.current;
      ffmpeg.on('log', ({ message }) => {
        console.log(message);
        setMsgString(message);
      });
      // toBlobURL is used to bypass CORS issue, urls with the same
      // domain can be used directly.
      await ffmpeg.load({
        coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, 'text/javascript'),
        wasmURL: await toBlobURL(`${baseURL}/ffmpeg-core.wasm`, 'application/wasm'),
      });
      setFFMPEGLoaded(true);
    }
  }

  const convert = async (output_type: 'gif' | 'mp4') => {
    const baseURL = process.env.REACT_APP_VERCEL_URL ? `https://${process.env.REACT_APP_VERCEL_URL}` : process.env.PUBLIC_URL;
    const ffmpeg = ffmpegRef.current;
    const selected_file = acceptedFiles.at(0);

    if (!selected_file) {
      throw new Error('Error loading file');
    }

    let input_filename = "input";
    if (selected_file.type === 'video/mp4') {
      input_filename += ".mp4";
    }
    else if (selected_file.type === 'image/jpeg') {
      throw new Error('Unsupported file type');
      input_filename += ".jpg";
    }
    else if (selected_file.type === 'image/png') {
      throw new Error('Unsupported file type');
      input_filename += ".png";
    }
    else {
      throw new Error('Unsupported file type');
    }


    const file = await selected_file.arrayBuffer()
    if (!file) {
      throw new Error('Error loading file');
    }
    const file_buffer = new Uint8Array(file);
    const file_base64 = btoa(
      file_buffer
        .reduce((data, byte) => data + String.fromCharCode(byte), '')
    );

    await ffmpeg.writeFile(input_filename, await fetchFile(`data:${selected_file.type};base64,${file_base64}`));
    await ffmpeg.writeFile('focused_left_dock.webm', await fetchFile(`${baseURL}/focused_left_dock.webm`));
    await ffmpeg.writeFile('fullscreen_flag_waving.webm', await fetchFile(`${baseURL}/fullscreen_flag_waving.webm`));

    if (selected_file.type.startsWith('video')) {
      console.log("video");

      if (output_type === 'gif') {
        await ffmpeg.exec(['-i', input_filename, '-stream_loop', '-1', '-i', 'focused_left_dock.webm', '-i', 'fullscreen_flag_waving.webm', '-filter_complex', '[1][0]scale2ref=w=oh*mdar:h=ih[dock][input];[dock][input]hstack=inputs=2:shortest=1[stacked];[stacked]scale=1280:720:force_original_aspect_ratio=decrease,pad=1280:720:-1:-1:color=black[stackuv];[stackuv]setsar=ratio=1[stackv];[2:v]trim=duration=5[flag];[flag]scale=1280:720:force_original_aspect_ratio=decrease,pad=1280:720:-1:-1:color=black[flaguv];[flaguv]setsar=ratio=1[flagv];[stackv][flagv]concat=n=2:v=1:a=0[outv]', '-vsync', '2', '-map', '[outv]', 'stacked.' + output_type]);
      }
      else if (output_type === 'mp4') {
        await ffmpeg.exec(['-i', input_filename, '-stream_loop', '-1', '-i', 'focused_left_dock.webm', '-i', 'fullscreen_flag_waving.webm', '-f', 'lavfi', '-t', '5', '-i', 'anullsrc', '-filter_complex', '[1][0]scale2ref=w=oh*mdar:h=ih[dock][input];[dock][input]hstack=inputs=2:shortest=1[stacked];[stacked]scale=1280:720:force_original_aspect_ratio=decrease,pad=1280:720:-1:-1:color=black[stackuv];[stackuv]setsar=ratio=1[stackv];[2:v]trim=duration=5[flag];[flag]scale=1280:720:force_original_aspect_ratio=decrease,pad=1280:720:-1:-1:color=black[flaguv];[flaguv]setsar=ratio=1[flagv];[stackv][0:a][flagv][3:a]concat=n=2:v=1:a=1[outv][outa]', '-vsync', '2', '-map', '[outv]', '-map', '[outa]', 'stacked.' + output_type]);
      }
      else {
        throw new Error('Unsupported output type');
      }

      const fileData = await ffmpeg.readFile('stacked.' + output_type);
      const data = new Uint8Array(fileData as ArrayBuffer);
      setMediaURL(URL.createObjectURL(
        new Blob([data.buffer], { type: output_type === 'gif' ? 'image/gif' : 'video/mp4' })
      ))
    }
    else if (selected_file.type.startsWith('image')) {
      throw new Error("not supported yet");
    }

  }

  return (
    <section className="container">
      {files.length === 0 &&
        <div {...getRootProps({ className: 'dropzone' })} style={{ border: '10px solid', padding: '100px' }}>
          <input {...getInputProps()} />
          <p>Drag or click to select a MP4 file to add motivation and blessings</p>
        </div>
      }
      {files.length > 0 &&
        <>

          <aside>
            <ul>{files}</ul>
          </aside>

          <div style={{ margin: "20px", fontSize: "15px" }}>
            <fieldset disabled={fileState!==FileState.SELECTED} defaultValue={"mp4"} >
                <input type="radio" id="mp4" name="mp4" value="mp4" checked={outputType === "mp4"} onClick={() => {setOutputType("mp4")}} />
                <label htmlFor="mp4">MP4</label>
                <input type="radio" id="gif" name="gif" value="gif" checked={outputType === "gif"} onClick={() => {setOutputType("gif")}}/>
                <label htmlFor="gif">GIF (No sound)</label>
                
            </fieldset>
          </div>

          <AwesomeButtonProgress type="primary" onPress={async (element, next) => {
            if (fileState === FileState.SELECTED) {
              setFileState(FileState.PROCESSING);
              await loadFFMPEG();
              await convert(outputType);
              next();
              setFileState(FileState.PROCESSED);
            }
            else if (fileState === FileState.PROCESSED && mediaURL) {
              console.log('Download action');
              window.location.href = mediaURL;
              next();
            }
          }}
            loadingLabel='Processing...'
            resultLabel='Done!'
          >
            {
              fileState === FileState.PROCESSED &&
              <>
                <span style={{ paddingRight: "5px" }}>
                  <DownloadIcon />
                </span>
                Respect. Download
              </>
              ||
              <>
                <span style={{ paddingRight: "5px" }}>
                  <RocketIcon />
                </span>
                Get blessings
              </>
            }
          </AwesomeButtonProgress>
          {
            fileState === FileState.PROCESSING &&
            <p style={{ fontFamily: "monospace", fontSize: '10px' }}>
              {msgString}
            </p>
          }

          {fileState === FileState.PROCESSED && mediaURL &&
            <div style={{ margin: "20px" }}>
              {
                outputType === 'gif' &&
                <img src={mediaURL} height={200} />
              }
              {
                outputType === 'mp4' &&
                <video
                  controls
                  height="200"
                  src={mediaURL} />
              }
            </div>
          }
        </>
      }

    </section>
  );
}


export default App;
